export default __webpack_public_path__ + "static/media/logo-brastemp@3x.dac9a28f.svg";